import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl/dist';

const ErrorMessage = props => {
    const { isVisible = false, messageText = false, textReplacements, errorWrapperClasses, errorClasses } = props;

    return isVisible ? (
        <div className={`${errorWrapperClasses ? errorWrapperClasses.join(' ') : ''}`}>
            <span
                className={`${isVisible ? 'shown' : 'hidden'} error--msg ${errorClasses ? errorClasses.join(' ') : ''}`}
            >
                <em>
                    <FontAwesomeIcon icon="exclamation" />
                </em>
                <FormattedMessage
                    id={messageText === false ? 'common.no_text' : messageText}
                    values={{ text: textReplacements }}
                />
            </span>
        </div>
    ) : null;
};

export default ErrorMessage;
